import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import Checkbox from '@material-ui/core/Checkbox';
import { getMyOwnDataById, eraseLotDataFromStore } from '../../../store/actions/negotiationLot/negotiationLotActions';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import CarsDetailIcon from '@material-ui/icons/DirectionsCar';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import SaveIcon from '@material-ui/icons/Save';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import NegotiationSubLotExpansionPanel from '../../Negotiation/EditLots/NegotiationSubLotExpansionPanel';
import CarsListContent from '../CarsList/CarsListContent';
import CarsListAPI from '../../../API/CarsListAPI';
import { FP_GROUP, FP_PHASE, LOT_SAVE_SUCCESS } from '../../../Utils/Constants';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import FirmPurchasesSaleChannels from './FirmPurchasesSaleChannels';
import { ConvertToBool, ConvertFromBool } from '../../Utils/GenericFunctions';


const styles = theme => ({
  paperL1: {
    padding: '120px 32px 12px',
    color: theme.palette.text.secondary
  },
  textBlack: {
    color: '#000000'
  },
  flex: {
    flex: 1
  },
  group: {
    display: 'inline-block'
  },
  carModelPaper: {
    padding: '0px 32px',
    backgroundColor: theme.palette.primary.light
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  appBar: {
    backgroundColor: '#F6F6F6'
  },
  gridDivider: {
    borderBottom: '2px solid #007b7a'
  },
  dividerMargin: {
    padding: '24px 0px 6px 0px'
  },
  headColor: {
    backgroundColor: '#A5A5A5',
    marginBottom: '12px'
  },
  textWhite: {
    color: '#ffffff'
  },
  divRoot: {
    width: '100%'
  },
  radioMargin: {
    marginLeft: '8px'
  },
  toolbarHeight: {
    minHeight: '52px'
  },
  saleChannelWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  }
});

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      fixedDecimalScale
      decimalScale={0}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};


class FirmPurchasesLotEditForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      loading: false,
      success: false,
      openSuccess: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      changedValueDetected: false,
      openError: false,
      alertMessage: '',
      openL4Edition: false,
      numReservationDays: -1,
      numExtensionDays: -1,
      originLocal: -1,
      deliveryDeadline: -1,
      stockAvailable: 'no',
      a1Created: 'no',
      transportManagement: 'no',
      reservation: 'no',
      enableNumReservationDays: false,
      enableNumExtensionDays: false,
      enableDeliveryDeadline: false,
      enableOriginLocal: false,
      enableStockAvailable: false,
      enableA1Created: false,
      enableTransportManagement: false,
      enableReservation: false,
      lotPhase: 'FirmPurchases',
      openDialogForced: false
    }
  }

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
      loading: false,
      success: false
    });
  };

  handleCloseDialogForced = () => {
    this.setState({ openDialogForced: false });
  };

  handleCloseL4Edition = () => {
    this.setState({ openL4Edition: false });
  };

  handleClose() {
    this.props.openEditFPLotMainForm();
    this.props.reloadFirmPurchasesLotsTableList();
    this.props.eraseLotDataFromStore();
  };

  handleCloseSnackbar = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      openSuccess: false,
      alertMessage: ''
    });
  };

  handleGoBack = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleClose,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleClose();
    }
  };

  handleClickEditCars = () => {
    this.setState({
      openL4Edition: true,
      enableNumReservationDays: false,
      enableNumExtensionDays: false,
      enableDeliveryDeadline: false,
      enableOriginLocal: false,
      enableStockAvailable: false,
      enableA1Created: false,
      enableTransportManagement: false,
      enableReservation: false
    });
  };

  handleClickEditL1L4 = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende GUARDAR a informação do Lote em Compras Firmes?',
      confirmationMessage: 'As informações alteradas relativas ao Lote serão guardadas no registo da viaturas correspondentes não sendo possível retroceder ou visualizar o estado anterior das mesmas.',
      confirmationFunction: () => this.handleSubmitEditL1L4(false),
      cancelFunction: this.handleCloseDialog
    });
  };

  handleConfirmForceSave = () => {
    this.setState({
      loading: false,
      openDialog: false,
      openDialogForced: true,
      confirmationQuestion: 'Tem a certeza que pretende GUARDAR a informação do Lote em Compras Firmes?',
      confirmationFunction: () => this.handleSubmitEditL1L4(true),
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleSubmitEditL1L4 = (ForceSave) => {
    const carAPI = new CarsListAPI();
    this.setState({ loading: true })
    let carDTO = this.parseStateForSubmit(this.state, ForceSave);
    carAPI.updateCarInformationByLot(carDTO, this.props.myLotData.L1ID).then(() => {
      this.setState({
        loading: false,
        success: true,
        changedValueDetected: false,
        openSuccess: true,
        alertMessage: LOT_SAVE_SUCCESS
      });
      this.handleCloseDialog();
      this.handleCloseDialogForced();
      this.props.reloadFirmPurchasesLotsTableList(); // this should be moved to  the handle close
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('Contacte os comercias') > -1) {
        this.setState({
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand +
            ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis, a mudança das flags de Stock e/ou Reserva terá impacto sobre as reservas. '
            + handleServerError(error)
        })
        this.handleConfirmForceSave();
      }
      else {
        this.setState({
          loading: false,
          success: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
      }
    });
  };

  parseStateForSubmit(estado, ForceSave) {
    let stockAvailable;
    let a1Created;
    let transportManagement;
    let reservation;

    if (estado.enableStockAvailable)
      stockAvailable = ConvertToBool(estado.stockAvailable);
    if (estado.enableA1Created)
      a1Created = ConvertToBool(estado.a1Created);
    if (estado.enableTransportManagement)
      transportManagement = ConvertToBool(estado.transportManagement);
    if (estado.enableReservation)
      reservation = ConvertToBool(estado.reservation);

    return {
      NumReservationDays: estado.enableNumReservationDays ? (estado.numReservationDays === -1 ? this.props.myLotData.ReservationDays : estado.numReservationDays) : '',
      NumExtensionDays: estado.enableNumExtensionDays ? (estado.numExtensionDays === -1 ? this.props.myLotData.ReservationExtendDays : estado.numExtensionDays) : '',
      DeliveryDeadline: estado.enableDeliveryDeadline ? (estado.deliveryDeadline === -1 ? this.props.myLotData.DeliveryDeadline : estado.deliveryDeadline) : '',
      OriginLocal: estado.enableOriginLocal ? (estado.originLocal === -1 ? this.props.myLotData.VehicleLocation : estado.originLocal) : '',
      StockAvailable: stockAvailable,
      A1Created: a1Created,
      TransportManagement: transportManagement,
      Reservation: reservation,
      ForceSave: ForceSave
    }
  }

  handleCheckboxchange = name => event => {
    this.setState({ [name]: event.target.checked });
  }

  handleChange = name => event => {
    this.setState({ [name]: handleSpecialCharacters(event.target.value) });
    this.detectChange();
  };

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  }

  undetectChange = () => {
    this.setState({ changedValueDetected: false });
  };

  render() {
    const { classes } = this.props;
    let subLots = [];
    if (this.props.negotiationSubLots) {
      let myObject = this.props.negotiationSubLots;
      for (var key in myObject) {
        if (myObject.hasOwnProperty(key)) {

          subLots.push(
            <NegotiationSubLotExpansionPanel
              key={key}
              subLotId={key}
              handleClose={this.handleClose.bind(this)}
              detectChange={this.detectChange.bind(this)}
              undetectChange={this.undetectChange.bind(this)}
              optionalsData={this.props.optionalsData}
              estadoId={this.props.myLotData.EstadoID}
              lotPhase={this.state.lotPhase}
            />
          );

        }
      }
    }
    return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={this.handleClose.bind(this)}
      >
        <AppBar className={classes.appBar}>

          <Toolbar className={classes.toolbarHeight} >

            <Tooltip title='Retroceder' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleGoBack}>
                <ReturnIcon />
              </Button>
            </Tooltip>

            <Typography variant='title' className={classNames(classes.flex, classes.textBlack)}>
              LOTE COMPRAS FIRMES
            </Typography>

            <Tooltip title='Viaturas' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickEditCars}>
                <CarsDetailIcon />
              </Button>
            </Tooltip>

            <Tooltip title='Guardar' placement='bottom' >
              <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickEditL1L4}
                disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}>
                <SaveIcon />
              </Button>
            </Tooltip>

          </Toolbar>

          <Paper className={classes.carModelPaper}>
            <Grid container spacing={8}>

              <Grid item xs={12} sm={4}>
                <TextField
                  id='brand'
                  label='MARCA'
                  margin='dense'
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.myLotData.Brand}
                />
              </Grid>

              <Grid item xs={12} sm={8}>
                <TextField
                  id='model'
                  label='MODELO'
                  margin='dense'
                  fullWidth
                  InputProps={{ readOnly: true }}
                  value={this.props.myLotData.Model}
                />
              </Grid>

            </Grid>
          </Paper>

        </AppBar>

        <Paper className={classes.paperL1}>

          <Grid container spacing={8}>

            <Grid item xs={12} sm={12}>
              <div className={classes.saleChannelWrapper}>
                <TextField
                  id='saleChannels'
                  fullWidth
                  label='CANAL DE VENDA'
                  InputProps={{ readOnly: true }}
                  value={this.props.myLotData.SaleChannel ? this.props.myLotData.SaleChannel.join(' || ') : ''}
                />
                <FirmPurchasesSaleChannels SaleChannels={this.props.myLotData.SaleChannel} LotStateID={this.props.myLotData.EstadoID} UserRoleType={this.props.user.UserRoleType} />
              </div>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='licensePlatePlan'
                label='PLANO DE MATRÍCULAS'
                fullWidth
                InputProps={{ readOnly: true }}
                value={this.props.myLotData.LicensePlatePlan}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='vehicleLocation'
                label='LOCALIZAÇÃO VEÍCULO NEGOCIAÇÃO'
                fullWidth
                InputProps={{ readOnly: true }}
                value={this.props.myLotData.VehicleLocation}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='lotLPPT'
                label='LOTE LPPT'
                fullWidth
                InputProps={{ readOnly: true }}
                value={this.props.myLotData.LotLPPT}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                id='formalizationDate'
                label='DATA FORMALIZAÇÃO'
                fullWidth
                InputProps={{ readOnly: true }}
                value={this.props.myLotData.FormalizationDate}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={8} justify='flex-start' alignItems='center' className={classes.inputArea} >
                <Grid item>
                  <FormLabel component='legend'>
                    AQUISIÇÃO C/ A1:
                  </FormLabel>
                </Grid>
                <Grid item>
                  <FormControl component='fieldset'>
                    <RadioGroup
                      aria-label='acquisitionA1'
                      name='acquisitionA1'
                      inputprops={{ readOnly: true }}
                      className={classes.group}
                      value={ConvertFromBool(this.props.myLotData.WithA1)}
                    >
                      <FormControlLabel name='yes' value='yes' control={<Radio disableRipple color='primary' />} label='Sim' />
                      <FormControlLabel name='no' value='no' control={<Radio disableRipple color='primary' />} label='Não' />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={8} justify='flex-start' alignItems='center' className={classes.inputArea} >
                <Grid item>
                  <FormLabel component='legend'>
                    VALOR DEBITADO:
                  </FormLabel>
                </Grid>
                <Grid item>
                  <FormControl component='fieldset'>
                    <RadioGroup
                      aria-label='amountDebited'
                      name='amountDebited'
                      inputprops={{ readOnly: true }}
                      className={classes.group}
                      value={ConvertFromBool(this.props.myLotData.AmountDebited)}
                    >
                      <FormControlLabel name='yes' value='yes' control={<Radio disableRipple color='primary' />} label='Sim' />
                      <FormControlLabel name='no' value='no' control={<Radio disableRipple color='primary' />} label='Não' />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id='lotObs'
                label='OBSERVAÇÕES'
                fullWidth
                multiline
                rows='1'
                rowsMax='3'
                InputProps={{ readOnly: true }}
                value={this.props.myLotData.Observations}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} className={classes.dividerMargin}>
            <Typography className={classes.gridDivider} variant='headline'>
              EDIÇÃO EM MASSA DO LOTE
            </Typography>
          </Grid>

          <Grid container spacing={8}>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    checked={this.state.enableNumReservationDays}
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    value={this.state.enableNumReservationDays}
                    onChange={this.handleCheckboxchange('enableNumReservationDays')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <TextField
                    id='numReservationDays'
                    label='Nº DIAS RESERVA'
                    fullWidth
                    value={this.state.numReservationDays === -1 ? this.props.myLotData.ReservationDays : this.state.numReservationDays}
                    onChange={this.handleChange('numReservationDays')}
                    disabled={!this.state.enableNumReservationDays && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1}
                    InputProps={{ readOnly: this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0, inputComponent: InputNumber }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableNumExtensionDays}
                    value={this.state.enableNumExtensionDays}
                    onChange={this.handleCheckboxchange('enableNumExtensionDays')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <TextField
                    id='numExtensionDays'
                    label='Nº DIAS PROLONGAMENTO'
                    fullWidth
                    value={this.state.numExtensionDays === -1 ? this.props.myLotData.ReservationExtendDays : this.state.numExtensionDays}
                    onChange={this.handleChange('numExtensionDays')}
                    disabled={!this.state.enableNumExtensionDays && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1}
                    InputProps={{ readOnly: this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0, inputComponent: InputNumber }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableDeliveryDeadline}
                    value={this.state.enableDeliveryDeadline}
                    onChange={this.handleCheckboxchange('enableDeliveryDeadline')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <TextField
                    id='deliveryDeadline'
                    label='PRAZO DE ENTREGA (dias úteis)'
                    fullWidth
                    value={this.state.deliveryDeadline === -1 ? this.props.myLotData.DeliveryDeadline : this.state.deliveryDeadline}
                    onChange={this.handleChange('deliveryDeadline')}
                    disabled={!this.state.enableDeliveryDeadline && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1}
                    InputProps={{ readOnly: this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0, inputComponent: InputNumber }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableOriginLocal}
                    value={this.state.enableOriginLocal}
                    onChange={this.handleCheckboxchange('enableOriginLocal')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <TextField
                    id='originLocal'
                    label='LOCAL DE ORIGEM'
                    fullWidth
                    disabled={!this.state.enableOriginLocal && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1}
                    inputProps={{ readOnly: this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0, maxLength: 200 }}
                    value={this.state.originLocal === -1 ? this.props.myLotData.VehicleLocation : this.state.originLocal}
                    onChange={this.handleChange('originLocal')}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableStockAvailable}
                    value={this.state.enableStockAvailable}
                    onChange={this.handleCheckboxchange('enableStockAvailable')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <Grid container justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        DISPONIBILIZAR PARA STOCK:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl disabled={!this.state.enableStockAvailable && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1} component='fieldset'>
                        <RadioGroup
                          name='stockAvailable'
                          className={classes.group}
                          inputprops={{ readOnly: this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0 }}
                          value={this.state.stockAvailable}
                          onChange={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0 ? null : this.handleChange('stockAvailable')}
                        >
                          <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                          <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableA1Created}
                    value={this.state.enableA1Created}
                    onChange={this.handleCheckboxchange('enableA1Created')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <Grid container justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        A1 CRIADO:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl disabled={!this.state.enableA1Created && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1} component='fieldset'>
                        <RadioGroup
                          name='a1Created'
                          className={classes.group}
                          value={this.state.a1Created}
                          onChange={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0 ? null : this.handleChange('a1Created')}
                        >
                          <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                          <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableTransportManagement}
                    value={this.state.enableTransportManagement}
                    onChange={this.handleCheckboxchange('enableTransportManagement')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <Grid container justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        GESTÃO DE TRANSPORTE:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl disabled={!this.state.enableTransportManagement && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1} component='fieldset'>
                        <RadioGroup
                          name='transportManagement'
                          className={classes.group}
                          value={this.state.transportManagement}
                          onChange={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0 ? null : this.handleChange('transportManagement')}
                        >
                          <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                          <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container justify='flex-start' alignItems='center'>
                <Grid item xs={12} sm={1}>
                  <Checkbox
                    color='primary'
                    disabled={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
                    checked={this.state.enableReservation}
                    value={this.state.enableReservation}
                    onChange={this.handleCheckboxchange('enableReservation')}
                  />
                </Grid>
                <Grid item xs={12} sm={11}>
                  <Grid container justify='flex-start' alignItems='center'>
                    <Grid item>
                      <FormLabel component='legend'>
                        RESERVA:
                      </FormLabel>
                    </Grid>
                    <Grid item>
                      <FormControl disabled={!this.state.enableReservation && this.props.user.UserRoleType.indexOf(FP_GROUP) > -1} component='fieldset'>
                        <RadioGroup
                          name='reservation'
                          className={classes.group}
                          value={this.state.reservation}
                          onChange={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0 ? null : this.handleChange('reservation')}
                        >
                          <FormControlLabel name='yes' value='yes' label='Sim' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                          <FormControlLabel name='no' value='no' label='Não' control={<Radio disableRipple={this.props.myLotData.EstadoID !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} classes={{ root: classes.radioMargin }} color='primary' />} />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

          </Grid>

          <div className={classes.divRoot}>
            {subLots}
          </div>

        </Paper>

        <CarsListContent estadoLotId={this.props.myLotData.EstadoID} openL4Edition={this.state.openL4Edition} handleGoBack={this.handleGoBack.bind(this)} handleCloseL4Edition={this.handleCloseL4Edition.bind(this)} reloadFirmPurchasesLotsTableList={this.props.reloadFirmPurchasesLotsTableList.bind(this)} optionalsData={this.props.optionalsData} />

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}>
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleClose.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialogForced}
          onClose={this.handleCloseDialogForced}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialogForced}
            handleClose={this.handleCloseDialogForced.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loading}
            success={this.state.success}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} openSuccess={this.state.openSuccess} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Dialog>
    );
  }
}

FirmPurchasesLotEditForm.propTypes = {
  classes: PropTypes.object.isRequired,
  openEditFPLotMainForm: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    myLotData: getMyOwnDataById(state, ownProps.nLotId),
    ...state
  }
};

const mapDispatchToProps = dispatch => ({
  eraseLotDataFromStore: () => dispatch(eraseLotDataFromStore())
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FirmPurchasesLotEditForm));


// WEBPACK FOOTER //
// ./src/components/FirmPurchases/EditLots/FirmPurchasesLotEditForm.js